import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesAsset = ({data}) => {
  return (
        <SupportServicesTable data={data} />
  );
};

export default SupportServicesAsset;
